type Tone = "green" | "amber" | "red" | "slate";

type KpiCardProps = {
  title: string;
  value: string | number;
  suffix?: string;
  hint?: string;
  tone?: Tone;
};

const toneMap: Record<
  Tone,
  { wrap: string; title: string; value: string; hint: string }
> = {
  green: {
    wrap: "bg-gradient-to-r from-green-50 to-green-100 border-green-200",
    title: "text-green-700",
    value: "text-green-800",
    hint: "text-green-700/80",
  },
  amber: {
    wrap: "bg-gradient-to-r from-amber-50 to-amber-100 border-amber-200",
    title: "text-amber-700",
    value: "text-amber-800",
    hint: "text-amber-700/80",
  },
  red: {
    wrap: "bg-gradient-to-r from-rose-50 to-rose-100 border-rose-200",
    title: "text-rose-700",
    value: "text-rose-800",
    hint: "text-rose-700/80",
  },
  slate: {
    wrap: "bg-white border-slate-200",
    title: "text-slate-600",
    value: "text-slate-900",
    hint: "text-slate-500",
  },
};

export default function KpiCard({
  title,
  value,
  suffix,
  hint,
  tone = "slate",
}: KpiCardProps) {
  const t = toneMap[tone] ?? toneMap.slate;

  return (
    <div className={`rounded-xl p-4 border card-shadow ${t.wrap}`}>
      <div className={`text-xs font-medium ${t.title}`}>{title}</div>
      <div className={`mt-1 text-2xl font-semibold tracking-tight ${t.value}`}>
        {value}
        {suffix ? (
          <span className="text-base font-normal ml-1">{suffix}</span>
        ) : null}
      </div>
      {hint ? <div className={`mt-2 text-xs ${t.hint}`}>{hint}</div> : null}
    </div>
  );
}
